<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          morematization Products
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/p21.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">用户停电互动智能管理系统</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            用户停电智能管理系统是基于小程序和公众号平台建立的一个用户交互系统，它
            针对于传统纸质停电通知单派送的局限，使整个派送停电通知单的过程更加智能
            化、信息化，不仅大大增加了停电通知信息的送达率，还可以及时了解用户们的
            反馈，大大提升了用户体验，增加了用户满意度。
          </div>
          <div class="title">相关案例</div>
          <div class="introimg">
            <img src='../assets/p22.png' alt="">
             <div class="intro" @click="gotoDetail">
              <span class="el-icon-right" ></span>
             </div>
          </div>
          
          <div class="txt last">用户停电互动智能管理系统</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">智能绑定	</div>
            <div class="en">Smart Binding</div>
            <div class="txt"><span class="el-icon-caret-right"></span>针对于原本的录入进系统的用户，在注册时，只需输入自己的户号并关注公众号即可进行绑定。(包括小程序和公众号之间的数据绑定、个人信息和线路之间的绑定、个人和程序之间的绑定)。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">远程访问</div>
            <div class="en">Remote access</div>
            <div class="txt"><span class="el-icon-caret-right"></span>此系统是采用微信小程序进行开发，支持远程访问，并且通知可以随时发放，打破地理位置的局限性。</div>
          </div>
          <div class="more_list end">
            <div class="title">线路独立	</div>
            <div class="en">Line independent</div>
            <div class="txt"><span class="el-icon-caret-right"></span>面对大区域内的用户，每一个用户的配电网线路都不尽相同，在程序逻辑中即对用户进行分区域通知，不会推送对于用户无用的信息。</div>
          </div>
          
        </div>
        <div class="more_bottom">
          <div class="more_list">
            <div class="title">用户反馈</div>
            <div class="en">User Feedback</div>
            <div class="txt"><span class="el-icon-caret-right"></span>用户可对停电计划作出反馈，大大提升用户满意度，增进用户和供电公司之间的交流沟通，提升对用户的服务质量。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code2.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail2')
    }
  }
}
</script>
<style scoped>
.introimg{
  display: flex;
    align-items: center;
}
.intro {
  text-align: center;
  width: 75px;
  height: 35px;
  line-height: 35px;
  background: #f5a93e;
  border-radius: 4px 4px 4px 4px;
  color: #FFFFFF ;
  margin-left: 30px;
  /* margin: 0 auto; */
  }
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  /* height: 200px; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor1.vue